import {
  getUserNameLocalStorage,
  getUserPreferenceLocalStorage,
  getlsDescFullStorage,
} from "../../../context/utils";
import { RowData } from "./PrintPageType";
import XlsExport from "./XlsExport";
import { ImageWithFallback } from "../Image/ImageWithFallback";
import { handleValueDataEmpytAudienceIndice } from "../Minute/MinuteUtils";
import { DivChartEnum } from "../../../utils/enums";
import i18n from "../../../i18n";
import React from "react";

export function maskNumericInteger(value: string): string {
  if (!value || typeof value !== "string") return value;
  if (value.includes(".") || value.includes(",")) return value;
  if (!/^\d+$/.test(value)) return value;

  // proteção contra CPU DoS
  const MAX_PROCESS_LENGTH = 10000;
  if (value.length > MAX_PROCESS_LENGTH) return value;

  let result = "";
  let count = 0;
  for (let i = value.length - 1; i >= 0; i--) {
    result = value.charAt(i) + result;
    count++;
    if (count === 3 && i !== 0) {
      result = "." + result;
      count = 0;
    }
  }
  return result;
}

export function fnReplacePoint(elementTable) {
  for (let i = 0, row; row === elementTable.rows[i]; i++) {
    row = handlingElementTableColumn(row, i);
  }
  return elementTable;
}

export function getColHeightfnReplacePoint(
  col: any,
  indice: number,
  originalColHeight: any
): string {
  let colHeight: string = "";

  if (indice === 0) {
    if (col.innerHTML.indexOf("img") === 1) {
      let pixelRatio = window.devicePixelRatio;
      if (pixelRatio >= 1.75) {
        colHeight = "54";
      } else if (pixelRatio >= 1.5) {
        colHeight = "46";
      } else if (pixelRatio >= 1.25) {
        colHeight = "38";
      } else {
        colHeight = "34";
      }
    }
  }
  return colHeight;
}
export function handlingElementTableColumn(row: any, indice: number): any {
  for (let j = 0, col; col === row.cells[j]; j++) {
    col.style.width = "75";
    col.style.textAlign = "center";
    col.style.verticalAlign = "middle";
    if (col.innerHTML.indexOf("span") === 1) {
      col.innerHTML = col.innerHTML.replace(".", ",");
    }
    col.style.height = getColHeightfnReplacePoint(
      col,
      indice,
      col.style.height
    );
  }
  return row;
}

export function getColumncelDet(rowID: any, val: any) {
  if (rowID === 1)
    return (
      <>
        <td className="printpage-celDet" key={rowID}>
          {val}
        </td>{" "}
      </>
    );

  if (rowID === 2)
    return (
      <>
        {" "}
        <td className="printpage-celDet" key={rowID}>
          <p style={{ margin: "0px" }}>
            <span>{val}</span>
          </p>
        </td>{" "}
      </>
    );
  else return <></>;
}

export function processXLSAddTAB_FIMByROW_MIN(
  ROW_MIN,
  indiceRow,
  RowSpan
): string {
  let TAB_FIM_result = "";
  for (let j = 0; j < ROW_MIN.cells.length; j++) {
    if (indiceRow === 0) {
      TAB_FIM_result +=
        '<th  style="width: 75px; text-align: center; vertical-align: middle;">' +
        ROW_MIN.cells[j].innerHTML +
        "</th>";
    } else {
      TAB_FIM_result += processXLSAddTAB_FIMByROW_MINDiferentZero(
        ROW_MIN,
        j,
        RowSpan
      );
    }
  }
  return TAB_FIM_result;
}

export function processXLSAddTAB_FIMByROW_MINDiferentZero(
  ROW_MIN,
  indiceRowJ,
  RowSpan
): string {
  let TAB_FIM_result = "";
  const currentCell = ROW_MIN?.cells?.[indiceRowJ];

  if (!currentCell) {
    return '<td style="text-align: center; vertical-align: middle;">-</td>';
  }

  if (RowSpan === 1) {
    TAB_FIM_result +=
      '<td style="text-align: center; vertical-align: middle;">' +
      currentCell.innerHTML +
      "</td>";
  } else {
    let rows = currentCell.getElementsByTagName("td");
    const cellLines = (currentCell.innerText || "")
      .split("\n")
      .map((line) => line.trim())
      .filter((line) => line.length > 0);

    const firstLine = rows[0]?.innerText ?? cellLines[0] ?? "-";
    const secondLine = rows[1]?.innerText ?? cellLines[1] ?? "-";

    TAB_FIM_result +=
      '<td style="text-align: center;">' +
      firstLine +
      "<br/>" +
      secondLine +
      "</td>";
  }
  return TAB_FIM_result;
}

export function processXLSAddTAB_FIMByROW_DET(ROW_DET, indiceRow): string {
  let TAB_FIM_result = "";
  for (let rowDetCell of ROW_DET.cells) {
    if (indiceRow === 0) {
      TAB_FIM_result +=
        '<th style="width: 75px; text-align: center; vertical-align: middle; height: 38px;">' +
        rowDetCell.innerHTML +
        "</th>";
    } else {
      TAB_FIM_result +=
        '<td style="text-align: center; vertical-align: middle;">' +
        rowDetCell.innerHTML +
        "</td>";
    }
  }
  return TAB_FIM_result;
}
export function processRenderTableRowFirstTipoBaseNotEqual0(
  rowID,
  row,
  rowContent,
  Target,
  rowFiltred,
  classColor
): JSX.Element {
  const rowDatas: RowData[] = [];
  row.map((val, valId) => {
    rowDatas.push({ Value: val, ValueId: Number(valId) });
  });

  const maskedRowFiltred = rowFiltred;

  return (
    <>
      {" "}
      <tr className={classColor}>
        {rowContent[2] === "" ? (
          rowDatas.map(
            (val, itemIndex) =>
              itemIndex === 1 && (
                <td
                  style={{ color: "yellow", textAlign: "center" }}
                  key={val.ValueId}
                >
                  <i
                    className="printpage-header-icon-13"
                    style={{ fontSize: "12px" }}
                  ></i>
                  {val.Value}
                </td>
              )
          )
        ) : (
          <td colSpan={1}>
            <div className="printpage-divfirstRow">
              <tr style={{ color: "black", textAlign: "center" }} key={rowID}>
                {maskedRowFiltred[0]}
              </tr>
              <tr style={{ textAlign: "center", color: "black" }}>
                <p style={{ margin: "0px" }}>
                  <i
                    className={"printpage-header-icon-" + Target}
                    style={{ fontSize: "12px" }}
                  ></i>
                  <span style={{ fontSize: "10px", color: "black" }}>
                    {maskedRowFiltred[1]}
                  </span>
                </p>
              </tr>
            </div>
          </td>
        )}
      </tr>{" "}
    </>
  );
}

export function processRenderTableRowFirstTipoBaseEqual0(
  row,
  rowContent,
  classColor
): JSX.Element {
  const rowDatas: RowData[] = [];
  row.map((val, valId) => {
    rowDatas.push({ Value: val, ValueId: Number(valId) });
  });
  return (
    <>
      {" "}
      <tr className={classColor}>
        {rowContent[2] === ""
          ? rowDatas.map(
            (val, itemIndex) =>
              itemIndex === 1 && (
                <td className="printpage-celDet" key={val.ValueId}>
                  {val.Value}
                </td>
              )
          )
          : rowDatas.map((val, rowID) => getColumncelDet(rowID, val.Value))}
      </tr>{" "}
    </>
  );
}

export function renderRows(indice, row): JSX.Element {
  const renderCell = (val) => {
    const maskedVal = typeof val === 'string' ? maskNumericInteger(val) : val;
    return processRenderRows(maskedVal, indice);
  };

  switch (indice) {
    case 0:
      return row.map((item, indexItem: number) => {
        const maskedVal = typeof item.Value === 'string' ? maskNumericInteger(item.Value) : item.Value;
        return (
          <td className="printpage-celDet" key={item.ValueId}>
            {maskedVal}
          </td>
        );
      });
    case 3:
    case 4:
    case 5:
      return row.map((item, indexItem: number) => (
        <td className="printpage-celDet" key={item.ValueId}>
          {renderCell(item.Value)}
        </td>
      ));
    default:
      return row.map((item, indexItem: number) => {
        const maskedVal = typeof item.Value === 'string' ? maskNumericInteger(item.Value) : item.Value;
        return (
          <td className="printpage-celDet" key={item.ValueId}>
            {maskedVal === "-"
              ? maskedVal
              : handleValueDataAudienceIndice(maskedVal, "%")}
          </td>
        );
      });
  }
}

export function processRenderRows(val, indice): JSX.Element {
  if (val === "-|-") {
    const splitVal = val.split("|");
    return (
      <>
        <div>
          {splitVal[0]}
          <br />
          <span className="printpage-celDet-down">{splitVal[1]}</span>
        </div>{" "}
      </>
    );
  } else if (indice !== 5) {
    const valStr = String(val || "");
    const parts = valStr.split("|");
    const part0 = maskNumericInteger(parts[0] || "");
    const part1 = maskNumericInteger(parts[1] || "");

    return (
      <>
        <div>
          {handleValueDataEmpytAudienceIndice(part0, "")}
          <br />
          <span className="printpage-celDet-down">
            {handleValueDataEmpytAudienceIndice(part1, "%")}
          </span>
        </div>{" "}
      </>
    );
  } else {
    const valStr = String(val || "");
    const parts = valStr.split("|");
    const part0 = maskNumericInteger(parts[0] || "");
    const part1 = maskNumericInteger(parts[1] || "");

    return (
      <>
        <div>
          {handleValueDataEmpytAudienceIndice(part0, "%")}
          <br />
          <span className="printpage-celDet-down">
            {handleValueDataEmpytAudienceIndice(part1, "%")}
          </span>
        </div>{" "}
      </>
    );
  }
}

export function handleValueDataAudienceIndice(
  valueData: string,
  sufix: string
): string {
  const maskedValue = typeof valueData === 'string' ? maskNumericInteger(valueData) : valueData;
  let resultValue = maskedValue === "Infinity" ? "∞" : maskedValue;

  if (maskedValue !== null && maskedValue !== undefined) {
    if (maskedValue !== "NaN" && maskedValue !== "Infinity" && maskedValue !== " ") {
      resultValue += sufix;
    }
    if (typeof maskedValue === 'string' &&
      (maskedValue.indexOf("NaN") >= 0 || maskedValue.indexOf("Infinity") >= 0)) {
      resultValue = resultValue.replace("%", "");
    }
  }
  return resultValue;
}

export function getTableRowFirstClass(Indice, rowID, ultima, pp_user): string {
  let classColor =
    Indice <= 2 && pp_user.userPreference?.TipoBase === 0
      ? " printpage-tableRow-lado"
      : " printpage-tableRow-emp ";
  classColor += rowID % 2 === 0 ? " printpage-odd" : " printpage-even";
  classColor += ultima ? " printpagefrist-ultima" : "";
  return classColor;
}

export function formatDate(strData) {
  let dtData = new Date(strData);

  if (i18n?.language?.toUpperCase() === "EN-US") {
    return (
      (dtData.getMonth() + 1).toString().padStart(2, "0") +
      "-" +
      dtData.getDate().toString().padStart(2, "0") +
      "-" +
      dtData.getFullYear().toString()
    );
  } else {
    return (
      dtData.getDate().toString().padStart(2, "0") +
      "-" +
      (dtData.getMonth() + 1).toString().padStart(2, "0") +
      "-" +
      dtData.getFullYear().toString()
    );
  }
}
export function capitalizeFirstLetter(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

export function getUserName() {
  return getUserNameLocalStorage();
}

export function downloadFile(ext, template) {
  let fileName = "Realtime." + ext;
  let base64 = function (s) {
    return window.btoa(decodeURI(encodeURIComponent(s)));
  };

  let uri = "data:application/vnd.ms-excel;base64,";
  let link = document.createElement("a");
  link.download = fileName;
  link.href = uri + base64(template);
  link.click();
}

export function getTableRowClass(Indice, rowID, ultima, pp_user): string {
  let classColor =
    Indice <= 2 && pp_user.userPreference?.TipoBase === 0
      ? " printpage-tableRow-lado"
      : " printpage-tableRow-emp ";
  classColor += rowID % 2 === 0 ? " printpage-odd" : " printpage-even";
  classColor += ultima ? " printpageDet-ultima" : "";
  return classColor;
}

export function formatCellForExport(cell: string, indice: number): string {
  if (cell === null || cell === undefined) return cell;
  if (cell === "-|-") return cell;

  const parts = (cell || "").split("|");
  const firstPart = maskNumericInteger(parts[0] ?? "");
  const secondPart = maskNumericInteger(parts[1] ?? "");

  const firstSuffix = indice === 1 || indice === 2 || indice === 5 ? "%" : "";
  const secondSuffix = "%";

  const formattedFirst = handleValueDataEmpytAudienceIndice(replaceFirstDotWithComma(firstPart), firstSuffix);
  const formattedSecond = handleValueDataEmpytAudienceIndice(replaceFirstDotWithComma(secondPart), secondSuffix);

  return `${formattedFirst}|${formattedSecond}`;
}

export function replaceFirstDotWithComma(value: string): string {
  if (!value) return value;
  return value.replace(/\./, ',');
}

export function formatAudienceForCSV(audience: any[][], indice: number): any[][] {
  if (!Array.isArray(audience)) return audience;
  return audience.map((row) =>
    Array.isArray(row)
      ? row.map((cell, colIdx) => {
        if (colIdx > 3 && typeof cell === "string") {
          return formatCellForExport(cell, indice);
        }
        return cell;
      })
      : row
  );
}

// Função utilitária para tratar valoresRow1 e valoresRow2 conforme o índice
export function processValoresComPercent(valoresRow1, valoresRow2, indice) {
  let valoresRow1Tratados = valoresRow1;
  let valoresRow2Tratados;
  if (typeof indice === "string" && indice.includes("RAT")) {
    valoresRow2Tratados = valoresRow2.map(v => (v !== undefined && v !== null && v !== "" && v !== "-" && !String(v).includes("%")) ? `${v}%` : v);
  } else {
    valoresRow1Tratados = valoresRow1.map(v => (v !== undefined && v !== null && v !== "" && v !== "-" && !String(v).includes("%")) ? `${v}%` : v);
    valoresRow2Tratados = valoresRow2.map(v => (v !== undefined && v !== null && v !== "" && v !== "-" && !String(v).includes("%")) ? `${v}%` : v);
  }
  return { valoresRow1Tratados, valoresRow2Tratados };
}

export function exportCSV(
  audiencePrint,
  audienceMediaCompPrint,
  pp_channels,
  translateService,
  pp_user,
  closePrint,
  imgs,
  DivChart,
  DivMinute
) {
  let a = audiencePrint;
  let mediaComp = audienceMediaCompPrint;
  let c = pp_channels.enabled;
  let userLocalStorageOld = getUserPreferenceLocalStorage();

  const currentTarget = pp_user?.userPreference?.Praca?.Targets?.find(
    (target) => target.Id === pp_user?.userPreference?.Target?.Id
  ) ?? pp_user?.userPreference?.Praca?.Targets?.[0];

  let u = [
    translateService("secret.classes.title"),
    currentTarget?.Desc ?? pp_user?.userPreference?.Target.Desc,
    translateService("rows.date"),
    formatDate(pp_user?.userPreference?.Data),
    translateService("secret.vars.title"),
    getlsDescFullStorage()?.replace("|", "-"),
    translateService("secret.groups.title"),
    pp_user?.userPreference?.Praca.Desc,
    translateService("secret.customer.title"),
    pp_user?.userPreference?.Customer?.Name ?? userLocalStorageOld?.Customer?.Name,
    capitalizeFirstLetter(translateService("login.username")),
    getUserName(),
  ];

  let others = [
    translateService("secret.rows.printTableTitle.list"),
    pp_user.userPreference.TipoBase,
    getlsDescFullStorage()?.split("|").length,
  ];

  let indice = pp_user?.userPreference?.Indice;

  // Prepara os dados de Minuto a Minuto
  const audienceFormatted = formatAudienceForCSV(a, indice);

  // Cria o objeto XlsExport com os dados normais primeiro
  let xls: XlsExport = new XlsExport(audienceFormatted, c, u, others, imgs, DivMinute);

  if (DivChart === DivChartEnum.MedComp && mediaComp.length > 0) {
    const mediaCompFormatted = formatAudienceForCSV(mediaComp, indice);
    xls.setMediaComparativas(mediaCompFormatted);
  }

  xls.exportCSV("realtime");
  closePrint();
}

export function exportXLS(pp_user, componentRef, closePrint, audienceMediaCompPrint?, DivChart?, DivMinute?) {
  let content = getPrintContentToExport(pp_user, componentRef, audienceMediaCompPrint, DivChart, DivMinute);

  const template =
    '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40">' +
    '<head><meta http-equiv="Content-Type" content="text/html; charset=UTF-8" />' +
    '<!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>Realtime</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--></head><body>' +
    content +
    '</body></html>';

  const filename = "RealtimeSheet";
  const downloadLink = document.createElement("a");
  downloadLink.type = "application/vnd.ms-excel;charset=utf-8";
  const blobSheet = new Blob(["\uFEFF" + template], { type: downloadLink.type });
  downloadLink.href = URL.createObjectURL(blobSheet);
  downloadLink.download = filename + ".xls";
  downloadLink.click();
  closePrint();
}
function processMediaCompBaseValue(baseAverage: any): string {
  let baseValue = baseAverage || "-";
  if (typeof baseValue === 'string' && baseValue.includes('|')) {
    baseValue = baseValue.split('|')[0];
  }
  if (typeof baseValue === 'string') {
    baseValue = baseValue.replace('%', '').replace(',', '').replace('.', '');
  }
  return baseValue;
}

function processMediaCompChannelValues(
  valoresRow1: any[],
  valoresRow2: any[],
  indice: any[],
  RowSpan: number
): string {
  let html = "";
  const { valoresRow1Tratados, valoresRow2Tratados } = processValoresComPercent(valoresRow1, valoresRow2, indice);

  for (let i = 0; i < valoresRow1Tratados.length; i++) {
    let cleanValue = valoresRow1Tratados[i];
    if (typeof cleanValue === 'string' && cleanValue.includes('|')) {
      cleanValue = cleanValue.split('|')[0] || "-";
    }
    html += `<td style="text-align: center; width: 75px; padding: 4px;">${cleanValue}</td>`;
  }

  if (valoresRow2Tratados !== undefined && valoresRow2Tratados.length > 0) {
    html += "</tr><tr>";

    const leadingCells = 2;
    for (let i = 0; i < leadingCells; i++) {
      html += `<td style="text-align: center; width: 75px; padding: 4px;"></td>`;
    }

    for (let i = 0; i < valoresRow2Tratados.length; i++) {
      let cleanValue = valoresRow2Tratados[i];
      if (typeof cleanValue === 'string' && cleanValue.includes('|')) {
        cleanValue = cleanValue.split('|')[0] || "-";
      }
      html += `<td style="text-align: center; width: 75px; padding: 4px;">${cleanValue}</td>`;
    }
  }

  return html;
}

function processMediaCompEmptyCells(colunasUsadas: number, numColunas: number): string {
  let html = "";
  for (let i = colunasUsadas; i < numColunas; i++) {
    html += `<td style="text-align: center; width: 75px; padding: 4px;">-</td>`;
  }
  return html;
}

function buildMediaCompRow(mediaRow: any[], RowSpan: number, numColunas: number): string {
  const dataRating = mediaRow[1] || "";
  const minutos = mediaRow[2] || "";
  const indice = mediaRow[3] || "";
  const baseAverage = mediaRow[4] || "";
  const valoresRow1 = mediaRow[5] || [];
  const valoresRow2 = mediaRow[6] || [];

  let html = "";
  // Linha do período
  html += `<tr><td colspan="${numColunas}" style="text-align: left; padding: 4px;">${dataRating} ${minutos}</td></tr>`;

  // Linha dos valores
  html += "<tr>";
  html += `<td style="text-align: center; width: 75px; padding: 4px;">${indice || 'RAT'}</td>`;

  const baseValue = processMediaCompBaseValue(baseAverage);
  html += `<td style="text-align: center; width: 75px; padding: 4px;">${baseValue}</td>`;


  html += processMediaCompChannelValues(valoresRow1, valoresRow2, indice, RowSpan);

  const valoresReferencia = Array.isArray(valoresRow2) && valoresRow2.length > 0 ? valoresRow2 : valoresRow1;
  const colunasUsadas = 2 + valoresReferencia.length;
  html += processMediaCompEmptyCells(colunasUsadas, numColunas);
  html += "</tr>";

  return html;
}

function buildMediaCompTable(audienceMediaCompPrint: any[], RowSpan: number, docContent: Document): string {
  let html = "<table style='width: 90%; table-layout: fixed; margin: 0 auto;'>";
  html += "<caption>Médias Comparativas</caption>";

  const TAB_DET_REF = docContent.getElementById("TAB_MEDIACOMP") as HTMLTableElement;
  const numColunas = TAB_DET_REF ? TAB_DET_REF.rows[0]?.cells.length || 0 : 0;

  audienceMediaCompPrint.forEach((mediaRow) => {
    if (Array.isArray(mediaRow) && mediaRow.length > 4) {
      html += buildMediaCompRow(mediaRow, RowSpan, numColunas);
    }
  });

  html += "</table><br/>";
  return html;
}

export function getPrintContentToExport(pp_user, componentRef, audienceMediaCompPrint?, DivChart?, DivMinute?) {
  let RowSpan = Number(pp_user.userPreference.TipoBase) === 1 ? 2 : 1;
  const firstColumnsCount = Number(pp_user.userPreference.TipoBase) === 0 ? 2 : 1;
  let refcontent = componentRef.current! as HTMLElement;
  let docContent = refcontent.ownerDocument;
  let TAB_FIM = "";
  TAB_FIM += docContent.getElementById("gridHeader")?.innerHTML;

  if (DivChart === DivChartEnum.MedComp && audienceMediaCompPrint.length > 0) {
    TAB_FIM += buildMediaCompTable(audienceMediaCompPrint, RowSpan, docContent);
  }
  let TAB_DET = docContent.getElementById("TAB_DET") as HTMLTableElement;

  TAB_DET = fnReplacePoint(TAB_DET);

  TAB_FIM += "<table>";

  // Usar o título correto baseado no DivMinute
  let headerTitle = "Minuto a Minuto"; // padrão
  if (DivMinute === 1) { // DivMinuteEnum.Media
    headerTitle = "Média";
  }

  // Criar o elemento LAB_HEADER com o título correto
  TAB_FIM += `<caption>${headerTitle}</caption>`;
  for (let i = 0; i < TAB_DET.rows.length; i++) {
    let currentRow = TAB_DET.rows[i];

    // Pega apenas as células iniciais (MIN/BASE) conforme TipoBase
    const firstTwoCells = Array.from(currentRow.cells).slice(0, firstColumnsCount);
    let ROW_MIN = {
      cells: firstTwoCells
    };

    // Pega as células restantes (dados dos canais)
    const remainingCells = Array.from(currentRow.cells).slice(firstColumnsCount);
    let ROW_DET = {
      cells: remainingCells
    };

    TAB_FIM += "<tr>";
    TAB_FIM += processXLSAddTAB_FIMByROW_MIN(ROW_MIN, i, RowSpan);
    TAB_FIM += processXLSAddTAB_FIMByROW_DET(ROW_DET, i);
    TAB_FIM += "</tr>";
  }
  TAB_FIM += "</table>";

  // Remove inline style from all <img> tags and convert to HTML attributes
  let content = TAB_FIM.replace(/<img([^>]+)style="([^"]*)"([^>]*)>/gi, (match, beforeStyle, styleValue, afterStyle) => {
    // Parse style string to extract width and height
    let widthMatch = styleValue.match(/width\s*:\s*([0-9.]+)px/);
    let heightMatch = styleValue.match(/height\s*:\s*([0-9.]+)px/);
    let widthAttr = widthMatch ? ` width="${widthMatch[1]}"` : "";
    let heightAttr = heightMatch ? ` height="${heightMatch[1]}"` : "";
    // Remove style attribute and add width/height as HTML attributes
    // Wrap the <img> in a <div> with text-align:center; vertical-align:middle for Excel compatibility
    return `<div style="text-align:center;vertical-align:middle;display:flex;align-items:center;justify-content:center;height:100%;"><img${beforeStyle}${widthAttr}${heightAttr}${afterStyle}></div>`;
  });

  // Remove any remaining style attributes from <img> tags
  content = content.replace(/(<img[^>]+)style="[^"]*"([^>]*>)/gi, (match, before, after) => {
    return `${before}${after}`;
  });

  return content;
}

export function PrintPageTableMediaComp({ audienceMediaCompPrint }) {
  if (!audienceMediaCompPrint?.length) return null;

  return (
    <>
      {audienceMediaCompPrint.map((item, idx) => {
        const dataRating = item[1];
        const minutos = item[2];
        const indice = item[3];
        const baseAverage = item[4];
        const valoresRow1 = item[5] || [];
        const valoresRow2 = item[6] || [];
        const { valoresRow1Tratados, valoresRow2Tratados } = processValoresComPercent(valoresRow1, valoresRow2, indice);

        return (
          <table
            key={`mediacomp-${idx}`}
            className="printpage-table"
            id="TAB_MEDIACOMP"
            style={{
              width: "90%",
              tableLayout: "fixed",
              margin: "10px auto",
              borderCollapse: "collapse",
            }}
          >
            <thead>
              {/* Linha com data e faixa de horário */}
              <tr>
                <th
                  colSpan={valoresRow1Tratados.length + 2}
                  className="printpage-headerFirst"
                  style={{
                    textAlign: "center",
                    backgroundColor: "#f3f3f3",
                    fontWeight: "bold",
                    padding: "4px",
                  }}
                >
                  {`${dataRating} ${minutos}`}
                </th>
              </tr>
            </thead>

            <tbody>
              {/* Linha principal de médias */}
              <tr>
                {/* RAT */}
                <td
                  className="printpage-mediaComp-lado"
                  style={{
                    textAlign: "center",
                    padding: "4px",
                    fontSize: "11px",
                    color: '#001e78',
                  }}
                >
                  {indice}
                </td>

                {/* BASE */}
                <td
                  className="printpage-mediaComp-lado"
                  style={{
                    textAlign: "center",
                    padding: "4px",
                    fontSize: "11px",
                    color: '#001e78',
                  }}
                >
                  {baseAverage}
                </td>

                {/* Valores */}
                {valoresRow1Tratados.map((val, i) => (
                  <td
                    key={`val-${i}`}
                    className="printpage-tableData"
                    style={{
                      textAlign: "center",
                      padding: "4px",
                      fontSize: "11px",
                      color: '#001e78'
                    }}
                  >
                    <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                      <span>{val || "-"}</span>
                      <span>
                        {valoresRow2Tratados && valoresRow2Tratados[i] !== undefined ? valoresRow2Tratados[i] : ""}
                      </span>
                    </div>
                  </td>
                ))}
              </tr>
            </tbody>
          </table>
        );
      })}
    </>
  );
}


export function PrintPageTableDet({
  pp_user,
  pp_channels,
  audiencePrint,
}): JSX.Element {
  const heightPage = window.innerHeight;
  let colSpanSize: number = pp_user?.userPreference?.TipoBase === 0 ? 2 : 1;
  let totCol = pp_channels?.enabled?.length;
  let HeaderWidth: number = Math.round(
    (100 / (totCol + colSpanSize)) * colSpanSize
  );
  let HeaderWidth2: number = 99 - HeaderWidth;
  const ultimaLinha = audiencePrint.slice(-1)[0];
  return (
    <table style={{ width: "90%", tableLayout: "fixed", margin: "0 auto" }} id="TAB_DET">
      <thead>
        <tr>
          {/* Header */}
          <React.Fragment>
            <th className="printpage-headerFirst-lado">MIN</th>
            <th className="printpage-headerFirst-lado">BASE</th>
          </React.Fragment>
          {/* Canais */}
          {pp_channels?.enabled?.map((head, headID) => (
            <th className="printpage-tableHeader" key={head.id}>
              <ImageWithFallback
                key={head.id}
                title={head.label}
                src={head.icons.menuBitmap}
                style={{ width: "30px", height: "30px", position: "relative", verticalAlign: "middle", display: "inline" }}
                dataid={head.id}
                className=""
                showTitle={false}
              />
            </th>
          ))}
        </tr>
      </thead>
      <tbody>
        {audiencePrint?.map((rowContent, rowID) =>
          rowContent === ultimaLinha ? (
            <React.Fragment key={`empty-${rowID}`}></React.Fragment>
          ) : (
            <PrintPageTableRowUnified
              key={`row-${rowID}`}
              rowContent={rowContent}
              rowID={rowID}
              ultima={false}
              ppUser={pp_user}
            />
          )
        )}
      </tbody>
      <tfoot>
        <PrintPageTableRowUnified
          rowContent={ultimaLinha}
          rowID={audiencePrint.length}
          ultima={true}
          ppUser={pp_user}
        />
      </tfoot>
    </table>
  );
}

export function PrintPageTableRowUnified({
  rowContent,
  rowID,
  ultima,
  ppUser,
}): JSX.Element {
  const Indice = ppUser.userPreference?.Indice;
  const Target = ppUser.userPreference?.Target.Id;
  const colSpanSize: number = ppUser.userPreference?.TipoBase === 0 ? 2 : 1;

  // Processa os dados das colunas de canais (após coluna 3)
  const channelData: RowData[] = [];
  rowContent.map((val, valId) => {
    if (valId > 3) {
      const maskedVal = typeof val === 'string' ? maskNumericInteger(val) : val;
      channelData.push({ Value: maskedVal, ValueId: Number(valId) });
    }
  });

  // Processa dados das primeiras colunas (MIN/BASE)
  const firstColumnData = Array.isArray(rowContent)
    ? rowContent.map((val, idx) =>
      idx > 3 && typeof val === "string" ? maskNumericInteger(val) : val
    )
    : rowContent;

  let classColor = getTableRowClass(Indice, rowID, ultima, ppUser);

  return (
    <tr className={classColor}>
      {/* Primeiras colunas (MIN/BASE) */}
      {/* Tipo Base != 0 (duas colunas) */}
      {rowContent[2] === "" ? (
        <>
          <td style={{ color: "yellow", textAlign: "center" }}>
            <i className="printpage-header-icon-13" style={{ fontSize: "12px" }}></i>
            {firstColumnData[1]}
          </td>
          <td style={{ textAlign: "center" }}>
            <i className={`printpage-header-icon-${Target}`} style={{ fontSize: "12px" }}></i>
            <span style={{ fontSize: "10px" }}>{firstColumnData[2]}</span>
          </td>
        </>
      ) : (
        <>
          <td className="printpage-celDet">{firstColumnData[1]}</td>
          <td className="printpage-celDet">
            <p style={{ margin: "0px" }}>
              <i className={`printpage-header-icon-${Target}`} style={{ fontSize: "12px" }}></i>
              <span>{firstColumnData[2]}</span>
            </p>
          </td>
        </>
      )}


      {/* Colunas dos canais (dados de audiência) */}
      {rowContent[2] === ""
        ? channelData.map((item, indexItem: number) => (
          <td
            style={{
              color: "black",
              textAlign: "center",
              borderRight: "1px solid #000",
            }}
            key={item.ValueId}
          >
            {handleValueDataAudienceIndice(item.Value, "-")}
          </td>
        ))
        : renderRows(Indice, channelData)}
    </tr>
  );
}

export function PrintPageHeader({ ppUser, translateService }): JSX.Element {
  let userLocalStorageOld = getUserPreferenceLocalStorage();

  const currentTarget = ppUser?.userPreference?.Praca?.Targets?.find(
    (target) => target.Id === ppUser?.userPreference?.Target?.Id
  ) ?? ppUser?.userPreference?.Praca?.Targets?.[0];

  if (ppUser !== undefined) {
    return (
      <table id="gridHeader">
        <tbody>
          <tr>
            <td>
              <div className="printpage-header-block">
                <dt className="printpage-header-label" style={{ fontWeight: "bold" }}>
                  {translateService("secret.classes.title")}
                </dt>
                <dd className="printpage-header-data">
                  {currentTarget?.Desc ?? ppUser?.userPreference?.Target?.Desc}
                </dd>
              </div>
            </td>
          </tr>
          <tr>
            <td>
              <div className="printpage-header-block">
                <dt className="printpage-header-label" style={{ fontWeight: "bold" }}>
                  {translateService("rows.date")}
                </dt>
                <dd className="printpage-header-data">
                  {formatDate(ppUser?.userPreference?.Data)}
                </dd>
              </div>
            </td>
          </tr>
          <tr>
            <td>
              <div className="printpage-header-block">
                <dt className="printpage-header-label" style={{ fontWeight: "bold" }}>
                  {translateService("secret.vars.title")}
                </dt>
                <dd className="printpage-header-data">
                  {getlsDescFullStorage()?.replace("|", "-")}
                </dd>
              </div>
            </td>
          </tr>
          <tr>
            <td>
              <div className="printpage-header-block">
                <dt className="printpage-header-label" style={{ fontWeight: "bold" }}>
                  {translateService("secret.groups.title")}
                </dt>
                <dd className="printpage-header-data">
                  {ppUser?.userPreference?.Praca.Desc.replace("REAL TIME", "")}
                </dd>
              </div>
            </td>
          </tr>
          <tr>
            <td>
              <div className="printpage-header-block">
                <dt className="printpage-header-label" style={{ fontWeight: "bold" }}>
                  {translateService("secret.customer.title")}
                </dt>
                <dd className="printpage-header-data">
                  {ppUser?.userPreference?.Customer?.Name ?? userLocalStorageOld?.Customer?.Name}
                </dd>
              </div>
            </td>
          </tr>
          <tr>
            <td>
              <div className="printpage-header-block">
                <dt className="printpage-header-label" style={{ fontWeight: "bold" }}>
                  {capitalizeFirstLetter(translateService("login.username"))}
                </dt>
                <dd className="printpage-header-data">{getUserName()}</dd>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    );
  } else {
    return <></>;
  }
}
